import { OktaAuth } from '@okta/okta-auth-js';
import "./index.css";

console.log("Issuer from env ", window._env_?.REACT_APP_OKTA_ISSUER || process.env.REACT_APP_OKTA_ISSUER)
const ISSUER = window._env_?.REACT_APP_OKTA_ISSUER || process.env.REACT_APP_OKTA_ISSUER;
if (!ISSUER && window.location.hostname !== 'localhost') {
  console.error("CRITICAL: REACT_APP_OKTA_ISSUER is missing from the environment config!");
}
const oktaConfig = {
  issuer: window._env_?.REACT_APP_OKTA_ISSUER || process.env.REACT_APP_OKTA_ISSUER,
  clientId: window._env_?.REACT_APP_OKTA_CLIENT_ID || process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window._env_?.REACT_APP_OKTA_REDIRECT_URI || process.env.REACT_APP_OKTA_REDIRECT_URI, 
  scopes: ['openid', 'profile', 'email', 'scope_data'],
  pkce: true,
  tokenManager: {
    storage: 'localStorage',
    autoRenew: true
  }, 
  transactionManager:{
    storage: 'localStorage'
  }
};

export const oktaAuth = new OktaAuth(oktaConfig);
